import React from 'react';
import { Gamepad2, ChevronRight, Star } from 'lucide-react';
import { RatingCircle } from './ui/RatingCircle';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-pinnacle-dark pt-20" data-id="element-82">
      {/* Background Grid/Glow */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(10,10,15,0.9),rgba(10,10,15,0.95)),url('https://images.unsplash.com/photo-1538481199705-c710c4e965fc?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center bg-no-repeat opacity-40 z-0" data-id="element-83"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-pinnacle-dark/50 to-pinnacle-dark z-0" data-id="element-84"></div>

      {/* Floating Elements - Decorative */}
      <div className="absolute top-1/4 left-10 md:left-20 animate-float hidden lg:block z-10" data-id="element-85">
        <div className="bg-pinnacle-card/80 backdrop-blur-md border border-pinnacle-green/30 p-4 rounded-2xl shadow-[0_0_30px_rgba(0,255,136,0.2)]" data-id="element-86">
          <div className="flex items-center gap-3" data-id="element-87">
            <RatingCircle score={98} size={50} data-id="element-88" />
            <div data-id="element-89">
              <p className="text-xs text-gray-400 uppercase tracking-wider" data-id="element-90">
                Masterpiece
              </p>
              <p className="font-bold text-white" data-id="element-91">Elden Ring</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-1/3 right-10 md:right-20 animate-float hidden lg:block z-10" style={{
      animationDelay: '2s'
    }} data-id="element-92">
        <div className="bg-pinnacle-card/80 backdrop-blur-md border border-pinnacle-cyan/30 p-4 rounded-2xl shadow-[0_0_30px_rgba(0,212,255,0.2)]" data-id="element-93">
          <div className="flex items-center gap-3" data-id="element-94">
            <RatingCircle score={92} size={50} data-id="element-95" />
            <div data-id="element-96">
              <p className="text-xs text-gray-400 uppercase tracking-wider" data-id="element-97">
                Must Play
              </p>
              <p className="font-bold text-white" data-id="element-98">Hades II</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 relative z-20 text-center" data-id="element-99">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-pinnacle-green/10 border border-pinnacle-green/20 text-pinnacle-green text-sm font-medium mb-6 animate-fade-in-up" data-id="element-100">
          <Star className="w-4 h-4 fill-current" data-id="element-101" />
          <span data-id="element-102">The New Standard in Game Ratings</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight tracking-tight animate-fade-in-up" style={{
        animationDelay: '0.1s'
      }} data-id="element-103">
          Stop Guessing. <br data-id="element-104" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-pinnacle-green to-pinnacle-cyan text-glow" data-id="element-105">
            Start Playing.
          </span>
        </h1>

        <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-10 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-106">
          PinnacleGames aggregates reviews from 150+ sources to give you the
          definitive score. No bias. No noise. Just the truth about every game.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up" style={{
        animationDelay: '0.3s'
      }} data-id="element-107">
          <button className="group relative px-8 py-4 bg-pinnacle-green text-pinnacle-dark font-bold rounded-lg overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(0,255,136,0.4)]" data-id="element-108">
            <span className="relative z-10 flex items-center gap-2" data-id="element-109">
              Browse Top Rated{' '}
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-110" />
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-111"></div>
          </button>

          <button className="px-8 py-4 bg-pinnacle-card border border-pinnacle-border text-white font-semibold rounded-lg hover:bg-pinnacle-border/50 transition-colors flex items-center gap-2" data-id="element-112">
            <Gamepad2 className="w-5 h-5 text-pinnacle-cyan" data-id="element-113" />
            How It Works
          </button>
        </div>
      </div>
    </section>;
}